<template>
  <scout-topic-panel
    title="会員検索"
    name="search"
    :is-tall="!!searchConditionId"
  >
    <template v-if="!hasEndedContract(contractId)">
      <template v-if="searchConditionId===undefined">
        <a
          class="boss-button boss-button-fill boss-button-search"
          href="javascript:void(0)"
        >
          <span>...</span>
        </a>
      </template>
      <template v-else>
        <a
          class="boss-button boss-button-fill boss-button-search"
          :class="{ 'margin-bottom-05' : !!searchConditionId }"
          href="javascript:void(0)"
          @click="showSearch(contractId, jobId)"
        >
          <span class="boss-button-before boss-icon-triangle" />
          <span>新規条件で検索</span>
        </a>
        <template v-if="!!searchConditionId">
          <a
            class="boss-button boss-button-fill boss-button-search boss-button-outline"
            href="javascript:void(0)"
            @click="showSearchResult(jobId, contractId)"
          >
            <span class="boss-button-before boss-icon-triangle" />
            <span>保存した検索条件</span>
          </a>
        </template>
      </template>
    </template>
  </scout-topic-panel>
</template>

<script>
import ScoutTopicPanel from '@/components/atoms/ScoutTopicPanel'
import { mapGetters } from 'vuex'

export default {
  components: { ScoutTopicPanel },
  props: {
    jobId: {
      type: Number,
      required: true
    },
    searchConditionId: {
      type: Number,
      default: undefined
    },
    contractId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'hasEndedContract'
    ])
  },
  methods: {
    showSearchResult (jobId, contractId) {
      this.$router.push(`/scouts/contracts/${contractId}/jobs/${jobId}/users/search_results`)
    },
    showSearch (contractId, jobId) {
      this.$router.push({
        name: 'scoutSearch',
        params: {
          create: true,
          jobId: jobId,
          contractId: String(contractId)
        }
      })
    }
  }
}

</script>
